import { useMemo, CSSProperties } from 'react';
import { CATEGORY } from '../../components/ui/categoryColors';

/** Series colors are data: one hue per plotted field, cycled by index. */
export const SERIES_COLORS = [
  CATEGORY.blue.ink.hex, CATEGORY.red.ink.hex, CATEGORY.emerald.ink.hex, CATEGORY.amber.ink.hex,
  CATEGORY.purple.ink.hex, CATEGORY.pink.ink.hex, CATEGORY.cyan.ink.hex, CATEGORY.orange.ink.hex,
];

/** Threshold lines and anomaly bands, in the severity hues. */
export const THRESHOLD_COLORS = {
  good: CATEGORY.emerald.ink.hex,
  warning: CATEGORY.amber.ink.hex,
  critical: CATEGORY.red.ink.hex,
};

export interface ChartTokens {
  axis: string;
  grid: string;
  primary: string;
  surface: string;
  raised: string;
}

const readToken = (name: string): string =>
  typeof window === 'undefined'
    ? ''
    : getComputedStyle(document.documentElement).getPropertyValue(name).trim();

// SVG presentation attributes and WebGL take literal colors, not var(), so the
// chart layer reads the tokens once per mount.
export const readChartTokens = (): ChartTokens => ({
  axis: readToken('--on-surface-variant'),
  grid: readToken('--outline-variant'),
  primary: readToken('--color-primary'),
  surface: readToken('--surface'),
  raised: readToken('--surface-container-highest'),
});

export const useChartTokens = (): ChartTokens => useMemo(readChartTokens, []);

/** Recharts tooltips render as HTML, so var() works here. */
export const TOOLTIP_CONTENT_STYLE: CSSProperties = {
  background: 'var(--surface-container-high)',
  border: 'none',
  borderRadius: 4,
  boxShadow: 'var(--np-overlay-shadow)',
  color: 'var(--on-surface)',
  fontSize: 11,
};

export const TOOLTIP_LABEL_STYLE: CSSProperties = {
  color: 'var(--on-surface-variant)',
};
